import { EElectricType, EFuelGrade, EFuelType } from '@/config/station';

import { TOption } from '@/types/common';

import { gradeToDisplayKey, typeToDisplayKey } from '@/pages/Admin/Transactions/ListView/utils';

export const FUEL_TYPE_OPTIONS: TOption<EFuelType>[] = [
  { value: EFuelType.GASOLINE, label: typeToDisplayKey(EFuelType.GASOLINE) },
  { value: EFuelType.DIESEL, label: typeToDisplayKey(EFuelType.DIESEL) },
  { value: EFuelType.ELECTRIC, label: typeToDisplayKey(EFuelType.ELECTRIC) },
];

export const FUEL_GRADE_OPTIONS: TOption<EFuelGrade>[] = [
  { value: EFuelGrade.ECONOMY, label: gradeToDisplayKey(EFuelGrade.ECONOMY) },
  { value: EFuelGrade.OCTANE_93, label: gradeToDisplayKey(EFuelGrade.OCTANE_93) },
  { value: EFuelGrade.REGULAR, label: gradeToDisplayKey(EFuelGrade.REGULAR) },
  { value: EFuelGrade.MID_GRADE, label: gradeToDisplayKey(EFuelGrade.MID_GRADE) },
  { value: EFuelGrade.PREMIUM, label: gradeToDisplayKey(EFuelGrade.PREMIUM) },
  { value: EFuelGrade.DIESEL, label: gradeToDisplayKey(EFuelGrade.DIESEL) },
  { value: EFuelGrade.FAST_CHARGE, label: gradeToDisplayKey(EFuelGrade.FAST_CHARGE) },
];

export const ELECTRIC_TYPE_OPTIONS: TOption<EElectricType>[] = [
  { value: EElectricType.KWH_722, label: EElectricType.KWH_722 },
];
